<template>
  <footer class="bg-white p-10 flex">
    <div class="mr-8">
      <a href="https://caseyhouse.com"
        ><img src="@/assets/svg/casey_house_logo.svg" alt="Casey House Logo"
      /></a>
    </div>
    <div class="">
      <address>
        Casey House Foundation
        <br />
        119 Isabella Street
        <br />
        Toronto, ON M4Y 1P2
        <br />
        416-962-7600
        <br />
        <a href="mailto:heart@caseyhouse.ca">heart@caseyhouse.ca</a>
      </address>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>